import { useEffect } from 'react';
import useUser from 'common/User/hooks/useUser.hook';
import { isNonEmptyArray, isExisty } from 'utils/helpers.util';
import Tracker from 'utils/Tracker';
import useCart from './useCart';
import Transform from 'utils/TransformData';
import useShipments from 'services/shipments/hooks/useShipments.hook';
import { initStorageManager } from 'utils/customStorage.util';
import {
  COUNTRY_CODE_KEY,
  PRODUCT_TYPE_FOOD,
  PRODUCT_TYPE_NON_FOOD,
} from 'pages/Cart/constants/cart.constants';
import useSessionArea from 'services/sessionArea/hooks/useSessionArea.hook';
import { getHashedEmail } from 'utils/cookies.util';
import { useSelector } from 'react-redux';
import { IAppState } from '@mafc/common';

const useGTMVirtualPageTrakingEffect = (pageType: string) => {
  const [sessionArea] = useSessionArea();
  const [isLoggedIn] = useUser();
  const { cartData } = useCart(false);
  const storage = initStorageManager(() => sessionStorage);
  const countryCode = storage.getItem(COUNTRY_CODE_KEY) || '';
  const cartId = 'current';
  const isCartEmpty = Object.keys(cartData).length === 0;
  const { shipments, standardFood, standardNonFood } = useShipments();
  const store = useSelector((state: IAppState) => state);

  useEffect(() => {
    const isCartAPICompleted = isExisty(shipments);
    if (!isCartAPICompleted) {
      return;
    }

    if (isNonEmptyArray(shipments as any[]) && isLoggedIn) {
      const orderType = [];

      if (isNonEmptyArray(standardFood.entries)) {
        orderType.push(PRODUCT_TYPE_FOOD);
      }
      if (isNonEmptyArray(standardNonFood.entries)) {
        orderType.push(PRODUCT_TYPE_NON_FOOD);
      }

      const data = {
        language: store.appConfig.language,
        order_type: orderType.join('_').toLowerCase(),
      };

      try {
        if (pageType === 'checkout') {
          const { totalPoints = '', cardNumber = '' } = store.userData;
          Tracker.emptyDataLayer();
          Tracker.gtmCheckoutPageReview({
            delivery_area_code: sessionArea,
            delivery_city:
              sessionArea && sessionArea.includes('-') ? sessionArea.split('-')[1].trim() : '',
            loyalty_point: totalPoints,
            my_club_member_id: cardNumber,
            hashed_email: getHashedEmail(),
            logged_in_status: '1',
            page_url: window.location.href,
            market: store,
          });
        }

        Tracker.gtmVirtualPage(pageType, data, store.appConfig.currency);
        if (!isCartEmpty) {
          const transformedData = Transform.productData(cartData, undefined, undefined, {
            ga4: false,
          });
          const ga4TransformedData = Transform.productData(cartData, undefined, undefined, {
            ga4: true,
            countryCode,
          });
          if (pageType === 'cart') {
            Tracker.gtmCartPageLoad(transformedData, '', false, {
              cartValue: String(cartData.subTotal.value),
            });
            Tracker.gtmCartPageLoad(ga4TransformedData, cartId, true, {
              cartValue: String(cartData.subTotal.value),
            });
          }
        }
      } catch (error) {
        // Data error
        // tslint:disable: no-console
        console.error(error);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExisty(shipments), isCartEmpty]);
};

export default useGTMVirtualPageTrakingEffect;
